import styled from 'styled-components';
import Icon, { ICON_CHAIR, ICON_USER } from '~/components/icon/index.js';

const ActivePlayersWrapper = styled.div`
	position: relative;
	left: 6px;
	top: 6px;
	display: flex;
	width: auto;
	height: 14px;
	padding: 0 2px;
	border-radius: 3px;
	background-color: var(--lc-live-casino-card-bg);
	.full-room {
		color: rgba(var(--full-room-color), 1);
		svg {
			fill: rgba(var(--full-room-color), 1);
		}
	}
	span {
		font: var(--label-regular);
		color: rgba(var(--active-players-color), 1);
		line-height: var(--active-players-line-height);
		font-size: var(--lc-card-font-size);
		margin: 0 2px;
	}
`;

const IconWrapper = styled.div`
	height: 8px;
	margin: auto;
`;

const showChair = type => {
	return ['blackjack', 'onebj'].includes(type?.toLowerCase());
};

const ActivePlayers = ({ totalSeats, activePlayers, type }) => {
	if (activePlayers === null || activePlayers === undefined) {
		return null;
	}

	const isShowChair = showChair(type) && totalSeats !== null && totalSeats !== undefined && totalSeats > 0;

	return (
		<ActivePlayersWrapper data-testid="active-players">
			<IconWrapper>
				{isShowChair ? (
					<Icon type={ICON_CHAIR} width="12" height="8" />
				) : (
					<Icon type={ICON_USER} width="12" height="8" />
				)}
			</IconWrapper>
			<span>{`${activePlayers}${isShowChair ? `/${totalSeats}` : ''}`}</span>
		</ActivePlayersWrapper>
	);
};

export default ActivePlayers;
